// Verlorene Anmeldung erkennen (Befund der KI-Prüfung vom 21.10.2026).
//
// App.svelte fragt /v2-api/auth/status genau einmal beim Start. Wurde die
// Sitzung danach widerrufen („Angemeldete Geräte") oder lief sie ab,
// antwortete jede Anfrage mit 401: die Stores behielten still ihren alten
// Stand, der WS-Hub klopfte endlos an, und die Statusleiste meldete
// „Server nicht erreichbar", obwohl er lief. Eine Anmeldemaske kam nie.
//
// Darum hängt das Erkennen wie die PIN-Abfrage (pin-stufe.ts) unter allen
// Anfragen, an fetch selbst -- viele Stores rufen fetch direkt, nicht über
// lib/api.ts. Ein 401 heißt aber nicht immer „abgemeldet": „PIN falsch"
// oder „Re-Auth abgelehnt" kommen auch so. Deshalb fragt die Wache bei
// einem 401 erst auth/status; nur wenn der Server dort „nicht angemeldet"
// sagt, ist die Anmeldung weg.

let eingehaengt = false;
let gemeldet = false;
let prueft = false;
let zuletzt = 0;

// Höchstens so oft nachfragen, wenn ein Endpunkt aus anderem Grund
// wiederholt 401 liefert und die Sitzung gilt.
const ABSTAND_MS = 10_000;

function betrifftApi(ziel: RequestInfo | URL): boolean {
  const roh = typeof ziel === "string" ? ziel : ziel instanceof URL ? ziel.href : ziel.url;
  try {
    const u = new URL(roh, window.location.href);
    return u.origin === window.location.origin && u.pathname.startsWith("/v2-api/");
  } catch {
    return false;
  }
}

/** Nach dem Start (angemeldet) einmal einhängen; `weg` läuft genau einmal,
 *  sobald der Server die Sitzung nicht mehr kennt. */
export function installiereAnmeldeWache(weg: () => void): void {
  if (eingehaengt || typeof window === "undefined") return;
  eingehaengt = true;
  const echt = window.fetch.bind(window);

  async function pruefe(): Promise<void> {
    if (gemeldet || prueft || Date.now() - zuletzt < ABSTAND_MS) return;
    prueft = true;
    zuletzt = Date.now();
    try {
      const r = await echt("/v2-api/auth/status", { credentials: "include", headers: { Accept: "application/json" } });
      // Antwortet der Server nicht, ist das kein Urteil über die Sitzung.
      if (!r.ok) return;
      const s = (await r.json()) as { auth_required?: boolean; authenticated?: boolean };
      if (s.auth_required && !s.authenticated) {
        gemeldet = true;
        weg();
      }
    } catch {
      // Netz weg: kein Urteil, der nächste 401 fragt wieder.
    } finally {
      prueft = false;
    }
  }

  window.fetch = async (...args: Parameters<typeof fetch>): Promise<Response> => {
    const r = await echt(...args);
    if (r.status === 401 && !gemeldet && betrifftApi(args[0])) void pruefe();
    return r;
  };
}
